import { element_is } from "svelte/internal"
import { openedElements } from "../../store"
import { get } from "svelte/store"

export default function changeOpenedElement(node: HTMLElement, type: "subPoint" | "mainPoint", footer, subPointId) {
    let currentElements = get(openedElements)
    let currentElement = currentElements[type]
    let underlineables = document.getElementsByClassName("underlineable")
    if (node !== currentElement) {
        node.scrollIntoView({ behavior: "smooth" })
    }
    Array.from(underlineables).forEach((e) => e.classList.remove("underlined"))

    if (currentElement === node) {
        // Handle closing the element
        if (footer) {
            let elements = [...document.getElementsByClassName("subPoint-footer")]
            elements.forEach((element) => {
                if (element !== currentElement) {
                    console.log(currentElement, element)
                    setTimeout(() => {
                        if (element) {
                            element.style.visibility = "hidden"
                            element.style.height = "0px"
                        }
                    }, 600)
                }
            })
        }
        currentElements[type] = null
        return { ...currentElements }
    } else {
        // Close the previous element if it's open
        if (currentElements.footer) {
            let elements = [...document.getElementsByClassName("subPoint-footer")]
            elements.forEach((element) => {
                if (element !== currentElement) {
                    console.log(currentElement, element)
                    setTimeout(() => {
                        if (element) {
                            //  element.style.visibility = "hidden"
                            //element.style.height = "0px"
                        }
                    }, 600)
                }
            })
        }
        // Open the new element
        currentElements[type] = node
        return { ...currentElements, footer: footer ? subPointId : footer }
    }
}
